import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryProductStatusListResponse,
  IInventoryProductStatusListResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useProductStatusListAPI = () => {
  const [productOrderStatus, setProductOrderStatus] = useState<IInventoryProductStatusListResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(`${INVENTORY_MODULE?.PRODUCT_STATUS_API?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryProductStatusListResponse>) => {
          if (res.data.status === true) {
            setProductOrderStatus(res.data.data);
          } else {
            setProductOrderStatus([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      setProductOrderStatus([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError)
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return { execute, productOrderStatus };
};
